import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'

export function* loadSccoWebserviceLog(action) {
  const {
    data: { page, pageSize, orderBy, orderType, accessToken, filter },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/scco-webservice-log`,
      { page, pageSize, orderBy, orderType, filter },
      { headers: { Authorization: `Bearer ${accessToken}` } },
    )
    yield put(actions.loadSccoWebserviceLog.success(res.data))
  } catch (err) {
    console.error(err.message)
    yield put(actions.loadSccoWebserviceLog.failure())
  }
}

export function* searchSccoMaster(action) {
  const {
    data: { service_name, search_text, page, pageSize, accessToken },
  } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/scco-webservice-log/search-master`,
      { service_name, search_text, page, pageSize },
      { headers: { Authorization: `Bearer ${accessToken}` } },
    )
    yield put(actions.searchSccoMaster.success(res.data))
  } catch (err) {
    console.error(err.message)
    yield put(actions.searchSccoMaster.failure())
  }
}

export function* loadRelatedTrucks(action) {
  const { driver_code, date_start, date_end, accessToken } = action.payload.data
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/scco-webservice-log/related-trucks`,
      { driver_code, date_start, date_end },
      { headers: { Authorization: `Bearer ${accessToken}` } },
    )
    yield put(actions.loadRelatedTrucks.success(res.data))
  } catch (err) {
    console.error(err.message)
    yield put(actions.loadRelatedTrucks.failure())
  }
}

export function* loadSccoServiceNames(action) {
  const { accessToken } = action.payload.data
  try {
    const res = yield call(
      axios.get,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/scco-webservice-log/service-names`,
      { headers: { Authorization: `Bearer ${accessToken}` } },
    )
    yield put(actions.loadSccoServiceNames.success(res.data))
  } catch (err) {
    console.error(err.message)
    yield put(actions.loadSccoServiceNames.failure())
  }
}

export default function* watchSccoWebserviceLog() {
  yield all([
    takeEvery(actions.LOAD_SCCO_WEBSERVICE_LOG.REQUEST, loadSccoWebserviceLog),
    takeEvery(actions.SEARCH_SCCO_MASTER.REQUEST, searchSccoMaster),
    takeEvery(actions.LOAD_RELATED_TRUCKS.REQUEST, loadRelatedTrucks),
    takeEvery(actions.LOAD_SCCO_SERVICE_NAMES.REQUEST, loadSccoServiceNames),
  ])
}
